import { ContextItemType } from 'src/@types/ai';
import { DocItem } from 'src/@types/docs';
import type { PopoverProps } from 'src/components/PopoverTrigger';
import { DocsExplorer } from 'src/components/explorer/docs/DocsExplorer';
import type { AIInputStateControl } from '../useAIInputState';

type Props = PopoverProps<{
  control: AIInputStateControl;
}>;

export const AIContextDocsMenu = ({ control, target, handleClose }: Props) => {
  const { toggleContextFiles, hasContextFile } = control((s) => ({
    toggleContextFiles: s.toggleContextFiles,
    hasContextFile: s.hasContextFile,
  }));

  return (
    <DocsExplorer
      open={!!target}
      anchorEl={target}
      onClose={handleClose}
      selectDoc={(doc: DocItem) => toggleContextFiles(ContextItemType.DOC, doc)}
      isSelected={(doc: DocItem) => hasContextFile(ContextItemType.DOC, doc)}
    />
  );
};
